export const batchOperate_config = ["BatchAddUser", "BatchUpdateUserStatus", "BatchUpdateUserType", "BatchDelete"];